
import Pagination from '../../../preliquidacion/components/pagination/pagination';
import TableDots from '../../../preliquidacion/components/tableDots/tableDots';

const ListadoPagosDisponibles = props => {
  const maxItems = 10;
  const currentPage = props.pagerList.currentPage - 1;
  const initialItem = currentPage * maxItems;
  const lastItem = initialItem + maxItems
  const paylistData = props.paylistData
    .slice(initialItem, lastItem);
  return (
    <div className="paylist-container">
      <div className="table-content">
        <div className="tableContentBorder table-responsive" onScroll={props.tools.handleScroll}>
          <TableDots tabIndex={1} />
          <Table condensed striped>
            <thead>
              <tr>
                <th className="text-center">
                  <label>
                    <input type="checkbox" checked={props.allSelected} id="selectAll" className="chk-style" autocomplete="off" onClick={e => props.handleChecked(e, true)} />
                  </label>
                </th>
                <th className="text-center month">{i18next.t('tituloTablaMes')}</th>
                <th className="text-center date">{i18next.t('tituloTablaFecha')}</th>
                <th className="text-center width-fixed">{i18next.t('tituloTablaEstado')}</th>
                <th className="text-center">{i18next.t('tituloTablaReferencia')}</th>
                <th className="text-center">{i18next.t('tituloTablaValor')}</th>
              </tr>
            </thead>
            <tbody>
              {
                paylistData.length ?
                  paylistData.map((month, index) => {
                    const nIndex = maxItems*currentPage + index;
                    const isMora = month['paymentState'] === 'En mora';
                    return (
                      <tr className={isMora? 'color-mora' : 'color-pending'} >
                        <td>
                          <div className="chk-container" htmlFor="selectMonth">
                            <label>
                              {
                                !deviceDetector.isMobile ? (
                                  <OverlayTrigger trigger={["hover"]} placement="top" overlay={(<Popover id="no-show" title="">{props.configurations['TextoTooltipListaPago']}</Popover>)}>
                                    <input type="checkbox" disabled={month['disabled']} checked={month['isSelected']} id="selectMonth" className="chk-style" autocomplete="off" onClick={e => props.handleChecked(e, false, nIndex)} />
                                  </OverlayTrigger>
                                ) : <input type="checkbox" disabled={month['disabled']} checked={month['isSelected']} id="selectMonth" className="chk-style" autocomplete="off" onClick={e => props.handleChecked(e, false, nIndex)} />
                              }
                            </label>
                          </div>
                        </td>
                        <td>{month['monthName']}</td>
                        <td>{month['payExpirationDate']}</td>
                        <td>
                          <span className={'label-status ' + (isMora? 'label-mora' : 'label-pending')}>{month['paymentState']}</span></td>
                        <td>{month['referenceNumber']}</td>
                        <td>{props.tools.textToCurrency(month['amountFee'].toString())}</td>
                      </tr>
                    )
                  })
                  : (
                    <tr>
                      <td colSpan={6}>
                        <div className="empty-container">
                          <div className="image-container">
                            <img src="/salud/Style%20Library/images/no_elements_table.png" />
                            <h3 className="table-title">{i18next.t('sinDatosPago')}</h3>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )
              }
            </tbody>
          </Table>
        </div>
        {
          props.pagerList.totalPages == 1 ? '' :
            <Pagination pager={props.pagerList} setPage={(page) => props.setPage(page, true)} />
        }
      </div>
    </div>
  )
}

const Table = ReactBootstrap.Table;
const OverlayTrigger = ReactBootstrap.OverlayTrigger;
const Popover = ReactBootstrap.Popover;

export default ListadoPagosDisponibles;